import { render, staticRenderFns } from "./ProductVariantBasicInfo.vue?vue&type=template&id=6fdfdf05&scoped=true&lang=pug&"
import script from "./ProductVariantBasicInfo.vue?vue&type=script&setup=true&lang=js&"
export * from "./ProductVariantBasicInfo.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ProductVariantBasicInfo.vue?vue&type=style&index=0&id=6fdfdf05&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fdfdf05",
  null
  
)

export default component.exports